import React, { Suspense } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { useSubheader } from "../../../../_metronic/layout";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { AddStores, ListStores } from "./index"
export const Test = () => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Test");

  return (
    <Switch>
      <Redirect
        exact={true}
        from="/test"
        to="/test/list"
      />
      <ContentRoute from="/test/add" component={AddStores} />
      <ContentRoute from="/test/list" component={ListStores} />
    </Switch>
  );
};
